import { Dialog, DialogContent, LinearProgress, Typography } from "@mui/material"
import { BoxFC } from "components/BoxCustom"
import React from "react"

/**
 * What บันทึก is doing while it uploads, and why it has stopped when the pacer is waiting
 * out the rate-limit window.
 *
 * Not dismissible on purpose: closing the document mid-upload would leave some vehicles
 * with their certificate and some without, and there is nothing useful to cancel to.
 *
 * @param progress  null when idle, otherwise { done, total, waitSec }
 */
const UploadProgressDialog = ({ progress }) => {

  if (!progress) return null

  const { done, total, waitSec } = progress
  const pct = total ? Math.round((done / total) * 100) : 0

  return (
    <Dialog open fullWidth maxWidth="xs">
      <DialogContent>
        <BoxFC gap={1.5} py={1}>
          <Typography variant="subtitle1">
            {waitSec > 0 ? "รอสักครู่..." : "กำลังบันทึกและอัปโหลดไฟล์"}
          </Typography>
          <LinearProgress variant={total ? "determinate" : "indeterminate"} value={pct} />
          <Typography variant="body2" color="text.secondary">
            {total ? `อัปโหลดแล้ว ${done}/${total} ไฟล์` : "กำลังบันทึกเอกสาร"}
          </Typography>
          {waitSec > 0 &&
            <Typography variant="caption" color="warning.main">
              ส่งครบจำนวนที่ระบบอนุญาตต่อนาทีแล้ว จะทำต่ออัตโนมัติในอีก {waitSec} วินาที
              — กรุณาอย่าปิดหน้าต่างนี้
            </Typography>
          }
        </BoxFC>
      </DialogContent>
    </Dialog>
  )
}

export default React.memo(UploadProgressDialog)
